// import CryptoJS from 'crypto-js';

// // Helper function for encryption
// const encryptData = (data, key) => {
//   return CryptoJS.AES.encrypt(JSON.stringify(data), key).toString();
// };

// // Helper function for decryption
// const decryptData = (encryptedData, key) => {
//   const bytes = CryptoJS.AES.decrypt(encryptedData, key);
//   return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
// };


// const password = sessionStorage.getItem('password');
// const userName = sessionStorage.getItem('userName');
const pythonApiUrl = "https://oneml.spectra.co/api";

export const generateFeasibility = async (oppId) => {
    try {
        // console.log(oppId); return

        const apiUrl = process.env.REACT_APP_API_URL;
        const requestBody = {
            "Action": "generateFeasibility",
            "Authkey": "ac7b51de9d888e1458dd53d8aJAN3ba6f",
            "oppid": oppId || "",
            "userName": sessionStorage.getItem('userName'),
            "password": sessionStorage.getItem('password')
        }

        const response = await fetch(apiUrl, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(requestBody),
        });
        const data = await response.json();
        return data;

    } catch (err) {
        console.error(err);
        return err.message;
    }
}


export const createSurveyTask = async (oppId) => {
    try {
        // console.log(oppId); return

        const apiUrl = process.env.REACT_APP_API_URL;
        const requestBody = {
            "Action": "createSurveyTask",
            "Authkey": "ac7b51de9d888e1458dd53d8aJAN3ba6f",
            "OppId": oppId || "",
            "userName": sessionStorage.getItem('userName'),
            "password": sessionStorage.getItem('password')
        }

        const response = await fetch(apiUrl, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(requestBody),
        });
        const data = await response.json();
        return data;

    } catch (err) {
        console.error(err);
        return err.message;
    }
}

export const getFeasibility = async (oppId) => {
    try {
        const apiUrl = process.env.REACT_APP_API_URL;

        const requestBody = {
            Action: "getFeasibility",
            Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
            oppid: oppId || "",
            userName: sessionStorage.getItem('userName'),
            password: sessionStorage.getItem('password')
        };

        const response = await fetch(apiUrl, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(requestBody),
        });

        const data = await response.json();
        return data;
    } catch (err) {
        console.error("Error fetching data:", err);
        return err.message;;
    }
};


export const getSurveyTask = async (oppId) => {
    try {
        const apiUrl = process.env.REACT_APP_API_URL;

        const requestBody = {
            Action: "getSurveyTask",
            Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
            OppId: oppId || "",
            userName: sessionStorage.getItem('userName'),
            password: sessionStorage.getItem('password')
        };

        const response = await fetch(apiUrl, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(requestBody),
        });

        const data = await response.json();
        return data;
    } catch (err) {
        console.error("Error fetching data:", err);
        return err.message;;
    }
};

export const getApproval = async (oppId) => {
    try {
        const apiUrl = process.env.REACT_APP_API_URL;

        const requestBody = {
            Action: "getApproval",
            Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
            oppid: oppId || "",
            userName: sessionStorage.getItem('userName'),
            password: sessionStorage.getItem('password')
        };

        const response = await fetch(apiUrl, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(requestBody),
        });

        const data = await response.json();
        return data;
    } catch (err) {
        console.error("Error fetching data:", err);
        return err.message;;
    }
};

export const createApproval = async (request) => {
    try {
        const apiUrl = process.env.REACT_APP_API_URL;

        const requestBody = {
            "Action": "createApproval",
            "Authkey": "ac7b51de9d888e1458dd53d8aJAN3ba6f",
            "oppid": request.oppId || "",
            "reason": request.reason || "",
            "userName": sessionStorage.getItem('userName'),
            "password": sessionStorage.getItem('password')
        }

        const response = await fetch(apiUrl, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(requestBody),
        });
        const data = await response.json();
        return data;

    } catch (err) {
        console.error(err);
        return err.message;
    }
}

export const getQuote = async (oppId) => {
    try {
        const apiUrl = process.env.REACT_APP_API_URL;

        const requestBody = {
            Action: "getQuote",
            Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
            oppid: oppId || "",
            userName: sessionStorage.getItem('userName'),
            password: sessionStorage.getItem('password')
        };

        const response = await fetch(apiUrl, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(requestBody),
        });

        const data = await response.json();
        return data;
    } catch (err) {
        console.error("Error fetching data:", err);
        return err.message;;
    }
};


export const getCompanyGroup = async (company) => {
    try {
        const apiUrl = process.env.REACT_APP_API_URL;

        const requestData = {
            Action: "getCompany",
            Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
            companyId: company || "New Company",
            password: sessionStorage.getItem('password'),
            userName: sessionStorage.getItem('userName'),
        };

        const response = await fetch(apiUrl, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(requestData),
        });

        const data = await response.json();
        return data;
    } catch (err) {
        console.error("Error fetching data:", err);
        return err.message;;
    }
};


export const getRelationship = async (company) => {
    try {
        const apiUrl = process.env.REACT_APP_API_URL;

        const requestData = {
            Action: "getRelationship",
            Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
            companyId: company || "",
            password: sessionStorage.getItem('password'),
            userName: sessionStorage.getItem('userName'),
        };
        // console.log(company);

        const response = await fetch(apiUrl, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(requestData),
        });

        const data = await response.json();
        return data;
    } catch (err) {
        console.error("Error fetching data:", err);
        return err.message;;
    }
};


export const getBuilding = async (payload) => {
    try {
        const apiUrl = process.env.REACT_APP_API_URL;

        const requestData = {
            Action: "getBuilding",
            Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
            areaCode: payload.areaCode,
            areaName: payload.areaName,
            password: sessionStorage.getItem('password'),
            userName: sessionStorage.getItem('userName'),
        };

        const response = await fetch(apiUrl, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(requestData),
        });

        const data = await response.json();
        return data;
    } catch (err) {
        console.error("Error fetching data:", err);
        return err.message;
    }
};


export const getArea = async (payload) => {
    try {
        const apiUrl = process.env.REACT_APP_API_URL;

        const requestData = {
            Action: "getArea",
            Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
            cityCode: payload.cityCode,
            cityName: payload.cityName,
            restrictedarea: false,
            stateCode: "",
            userName: sessionStorage.getItem('userName'),
            password: sessionStorage.getItem('password')
        };

        const response = await fetch(apiUrl, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(requestData),
        });

        const data = await response.json();
        return data;
    } catch (err) {
        console.error("Error fetching data:", err);
        return err.message;
    }
};


export const getPreTask = async (oppId) => {
    try {
        const apiUrl = process.env.REACT_APP_API_URL;

        const requestData = {
            "Action": "getPreTask",
            "Authkey": "ac7b51de9d888e1458dd53d8aJAN3ba6f",
            "oppId": oppId,
            "preSalesId": "",
            "userName": sessionStorage.getItem('userName'),
            "password": sessionStorage.getItem('password')
        };

        const response = await fetch(apiUrl, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(requestData),
        });

        const data = await response.json();
        return data;
    } catch (err) {
        console.error("Error fetching data:", err);
        return err.message;
    }
};


export const getIR = async (cafId) => {
    try {
        const apiUrl = process.env.REACT_APP_API_URL;

        const requestData = {
            Action: "getIR",
            Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
            cafNo: cafId,
            userName: sessionStorage.getItem('userName'),
            password: sessionStorage.getItem('password')
        };

        const response = await fetch(apiUrl, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(requestData),
        });

        const data = await response.json();
        return data;
    } catch (err) {
        console.error("Error fetching data:", err);
        return err.message;
    }
};


export const getNP = async (cafId) => {
    try {
        const apiUrl = process.env.REACT_APP_API_URL;

        const requestData = {
            Action: "getNP",
            Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
            cafNo: cafId,
            userName: sessionStorage.getItem('userName'),
            password: sessionStorage.getItem('password')
        };

        const response = await fetch(apiUrl, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(requestData),
        });

        const data = await response.json();
        return data;
    } catch (err) {
        console.error("Error fetching data:", err);
        return err.message;
    }
};


export const getWCR = async (cafId) => {
    try {
        const apiUrl = process.env.REACT_APP_API_URL;

        const requestData = {
            Action: "getWCR",
            Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
            cafNo: cafId,
            userName: sessionStorage.getItem('userName'),
            password: sessionStorage.getItem('password')
        };

        const response = await fetch(apiUrl, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(requestData),
        });

        const data = await response.json();
        return data;
    } catch (err) {
        console.error("Error fetching data:", err);
        return err.message;
    }
};


export const getCafDZationB = async (payload) => {
    try {
        const apiUrl = process.env.REACT_APP_API_URL;
        const requestData = {
            "Authkey": "ac7b51de9d888e1458dd53d8aJAN3ba6f",
            "Action": "getCafDZationB",
            "cafNo": payload.cafNo || "",
            "oppid": payload.oppid || "",
            "safNo": payload.safNo || "",
            userName: sessionStorage.getItem('userName'),
            password: sessionStorage.getItem('password')
        }

        const response = await fetch(apiUrl, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(requestData),
        });

        const data = await response.json();
        return data;
    } catch (err) {
        console.error("Error fetching data:", err);
        return err.message;
    }
};


export const getSpecState = async (payload) => {
    try {
        const apiUrl = process.env.REACT_APP_API_URL_2;
        const requestData = {
            Action: "getSpecState",
            Authkey: "AdgT6SnjAkeLqlkE4",
            userName: sessionStorage.getItem('userName'),
            password: sessionStorage.getItem('password')
        };

        const response = await fetch(apiUrl, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(requestData),
        });

        const data = await response.json();
        return data;
    } catch (err) {
        console.error("Error fetching data:", err);
        return err.message;
    }
};


export const getCity = async (stateCode) => {
    try {
        const apiUrl = process.env.REACT_APP_API_URL;
        const requestData = {
            Action: "getCity",
            Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
            stateCode: stateCode,
            userName: sessionStorage.getItem('userName'),
            password: sessionStorage.getItem('password')
        }

        const response = await fetch(apiUrl, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(requestData),
        });

        const data = await response.json();
        return data;
    } catch (err) {
        console.error("Error fetching data:", err);
        return err.message;
    }
};


export const updateOppProduct = async (payload) => {
    try {
        const apiUrl = process.env.REACT_APP_API_URL;
        const requestData = {
            "Action": "updateOppProduct",
            "Authkey": "ac7b51de9d888e1458dd53d8aJAN3ba6f",
            "oppid": payload.oppid || "",
            "siteId": payload.siteId || "",
            "productid": payload.productid || "",
            "discount": payload.discount || "",
            "quantity": payload.quantity || "1",
            "priceperunit": payload.priceperunit || "",
            "pricing": payload.pricing || "Use Default",   // OR "Override Price":"Use Default"
            userName: sessionStorage.getItem('userName'),
            password: sessionStorage.getItem('password')
        }

        const response = await fetch(apiUrl, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(requestData),
        });

        const data = await response.json();
        return data;
    } catch (err) {
        console.error("Error fetching data:", err);
        return err.message;
    }
};


export const getOppProduct = async (payload) => {
    try {
        const apiUrl = process.env.REACT_APP_API_URL;
        const requestData = {
            "Action": "getOppProduct",
            "Authkey": "ac7b51de9d888e1458dd53d8aJAN3ba6f",
            "oppid": payload.oppid || "",
            "siteId": payload.siteId || "",
            userName: sessionStorage.getItem('userName'),
            password: sessionStorage.getItem('password')
        }

        // console.log(requestData);


        const response = await fetch(apiUrl, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(requestData),
        });

        const data = await response.json();
        return data;
    } catch (err) {
        console.error("Error fetching data:", err);
        return err.message;
    }
};


export const getopportunity = async (payload) => {
    try {
        const apiUrl = process.env.REACT_APP_API_URL;
        const requestData = {
            "Action": "getopportunity",
            "Authkey": "ac7b51de9d888e1458dd53d8aJAN3ba6f",
            "LeadId": payload.LeadId || "",
            "OppId": payload.oppid || "",
            "userName": sessionStorage.getItem('userName'),
            "password": sessionStorage.getItem('password')
        }

        const response = await fetch(apiUrl, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(requestData),
        });

        const data = await response.json();
        return data;
    } catch (err) {
        console.error("Error fetching data:", err);
        return err.message;
    }
};

export const getopportunityWiFi = async (oppid) => {
    try {
        const apiUrl = process.env.REACT_APP_API_URL;
        const requestData = {
            "Action": "getopportunityWiFi",
            "Authkey": "ac7b51de9d888e1458dd53d8aJAN3ba6f",
            "OppId": oppid || "",
            "userName": sessionStorage.getItem('userName'),
            "password": sessionStorage.getItem('password')
        }

        const response = await fetch(apiUrl, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(requestData),
        });

        const data = await response.json();
        return data;
    } catch (err) {
        console.error("Error fetching data:", err);
        return err.message;
    }
};


export const customerImageOnCAF = async (payload) => {
    try {
        const apiUrl = process.env.REACT_APP_API_URL;

        const requestData = {
            "Action": "customerImageOnCAF",
            "Authkey": "ac7b51de9d888e1458dd53d8aJAN3ba6f",
            "OppId": payload?.Oppid || "",
            "CafID": payload?.CafID || "",
            "CustomerFileNameWithExtension": payload?.CustomerFileNameWithExtension || "",
            "CustomerFileContent": payload?.CustomerFileContent || "",
            "userName": sessionStorage.getItem('userName'),
            "password": sessionStorage.getItem('password')
        }

        const response = await fetch(apiUrl, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(requestData),
        });

        const data = await response.json();
        return data;
    } catch (err) {
        console.error("Error fetching data:", err);
        return err.message;
    }
};


export const createUserlicenceGrid = async (payload) => {
    try {
        const apiUrl = process.env.REACT_APP_API_URL;

        const requestData = {
            "Action": "createUserlicenceGrid",
            "Authkey": "ac7b51de9d888e1458dd53d8aJAN3ba6f",
            "OppId": payload?.Oppid || "",
            "UserType": payload?.UserType || "",
            "NoofUserLicensesrequired": payload?.NoofUserLicensesrequired || "",
            "SpeedPerUser": payload?.SpeedPerUser || "",
            "PlanValidityDataVolumeCriteria": payload?.PlanValidityDataVolumeCriteria || "",
            "DataVolumeinGB": payload?.DataVolumeinGB || "",
            "DevicesperUser": payload?.DevicesperUser || "",
            "LoginMechanism": payload?.LoginMechanism || "",
            "userName": sessionStorage.getItem('userName'),
            "password": sessionStorage.getItem('password')
        }

        const response = await fetch(apiUrl, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(requestData),
        });

        const data = await response.json();
        return data;
    } catch (err) {
        console.error("Error fetching data:", err);
        return err.message;
    }
};



export const getUserlicencegrid = async (Oppid) => {
    try {
        const apiUrl = process.env.REACT_APP_API_URL;

        const requestData = {
            "Action": "getUserlicencegrid",
            "Authkey": "ac7b51de9d888e1458dd53d8aJAN3ba6f",
            "OppId": Oppid || "",
            "userName": sessionStorage.getItem('userName'),
            "password": sessionStorage.getItem('password')
        }

        const response = await fetch(apiUrl, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(requestData),
        });

        const data = await response.json();
        return data;
    } catch (err) {
        console.error("Error fetching data:", err);
        return err.message;
    }
};


export const updateopportunityWiFi = async (payload) => {
    try {
        const apiUrl = process.env.REACT_APP_API_URL;
        // console.log(payload);

        // const requestData = {
        //     "Action": "updateopportunityWiFi",
        //     "Authkey": "ac7b51de9d888e1458dd53d8aJAN3ba6f",
        //     "OppId": payload?.Oppid || "", 
        //     "CafID": payload?.CafID || "", 
        //     "CustomerFileNameWithExtension": payload?.CustomerFileNameWithExtension || "",
        //     "CustomerFileContent": payload?.CustomerFileContent || "",
        //     "userName": userName,
        //     "password": password
        // }

        const response = await fetch(apiUrl, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(payload),
        });

        const data = await response.json();
        return data;
    } catch (err) {
        console.error("Error fetching data:", err);
        return err.message;
    }
};

export const sendCustomerLiveImageURL = async (payload) => {
    try {
        const apiUrl = process.env.REACT_APP_API_URL;
        // console.log(payload);

        const requestData = {
            "Action": "sendCustomerLiveImageURL",
            "Authkey": "ac7b51de9d888e1458dd53d8aJAN3ba6f",
            "OppId": payload?.OppId || "",
            "CafID": payload?.CafID || "",
            "CustomerLink": payload?.CustomerLink,
            "userName": sessionStorage.getItem('userName'),
            "password": sessionStorage.getItem('password')
        }

        const response = await fetch(apiUrl, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(requestData),
        });

        const data = await response.json();
        return data;
    } catch (err) {
        console.error("Error fetching data:", err);
        return err.message;
    }
};

export const deleteOpportunityProduct = async (payload) => {
    try {
        const apiUrl = process.env.REACT_APP_API_URL;
        const requestData = {
            "Action": "deleteOpportunityProduct",
            "Authkey": "ac7b51de9d888e1458dd53d8aJAN3ba6f",
            "Oppid": payload.Oppid || "",
            "siteId": payload.siteId || "",
            "productid": payload.productid || "",
            userName: sessionStorage.getItem('userName'),
            password: sessionStorage.getItem('password')
        }

        // console.log(requestData);


        const response = await fetch(apiUrl, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(requestData),
        });

        const data = await response.json();
        return data;
    } catch (err) {
        console.error("Error fetching data:", err);
        return err.message;
    }
};


export const getAllSiteDetails = async (oppId) => {
    try {
        const apiUrl = process.env.REACT_APP_API_URL;

        const requestBody = {
            Action: "getAllSiteDetails",
            Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
            oppID: oppId || "",
            userName: sessionStorage.getItem('userName'),
            password: sessionStorage.getItem('password')
        };

        const response = await fetch(apiUrl, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(requestBody),
        });

        const data = await response.json();
        return data;
    } catch (err) {
        console.error("Error fetching data:", err);
        return err.message;;
    }
};



export const getBBDIAEmpCount = async () => {
    try {
        const apiUrl = process.env.REACT_APP_API_URL;

        const requestBody = {
            Action: "getBBDIAEmpCount",
            Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
        };

        const response = await fetch(apiUrl, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(requestBody),
        });

        const data = await response.json();
        return data;
    } catch (err) {
        console.error("Error fetching data:", err);
        return err.message;;
    }
};


export const getBBDIAOffArea = async (empCount) => {
    try {
        const apiUrl = process.env.REACT_APP_API_URL;

        const requestBody = {
            Action: "getBBDIAOffArea",
            Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
            empCount: empCount
        };

        const response = await fetch(apiUrl, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(requestBody),
        });

        const data = await response.json();
        return data;
    } catch (err) {
        console.error("Error fetching data:", err);
        return err.message;;
    }
};


export const getBBDIA_AP = async (payload) => {
    try {
        const apiUrl = process.env.REACT_APP_API_URL;

        const requestBody = {
            Action: "getBBDIA_AP",
            Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
            empCount: payload.empCount || "",
            OfficeArea: payload.OfficeArea || ""
        };

        const response = await fetch(apiUrl, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(requestBody),
        });

        const data = await response.json();
        return data;
    } catch (err) {
        console.error("Error fetching data:", err);
        return err.message;;
    }
};


export const getBBDIA_Plan = async (payload) => {
    try {
        const apiUrl = process.env.REACT_APP_API_URL;

        const requestBody = {
            Action: "getBBDIA_Plan",
            Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
            empCount: payload.empCount || "",
            OfficeArea: payload.OfficeArea || "",
            AP: payload.AP || ""
        };

        const response = await fetch(apiUrl, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(requestBody),
        });

        const data = await response.json();
        return data;
    } catch (err) {
        console.error("Error fetching data:", err);
        return err.message;;
    }
};


export const getBBDIAPlanPrice = async (payload) => {
    try {
        const apiUrl = process.env.REACT_APP_API_URL;

        const requestBody = {
            Action: "getBBDIAPlanPrice",
            Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
            empCount: payload.empCount || "",
            OfficeArea: payload.OfficeArea || "",
            AP: payload.AP || "",
            planName: payload.planName || ""
        };

        const response = await fetch(apiUrl, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(requestBody),
        });

        const data = await response.json();
        return data;
    } catch (err) {
        console.error("Error fetching data:", err);
        return err.message;;
    }
};


export const createUpdateOppProductBBDIA = async (payload) => {
    try {
        const apiUrl = process.env.REACT_APP_API_URL;

        const requestBody = {
            Action: "createUpdateOppProductBBDIA",
            Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
            contactID: payload.contactID || "",
            Oppid: payload.Oppid || "",
            productid: payload.productid || "",
            EmployeeCount: payload.EmployeeCount || "",
            OfficeArea: payload.OfficeArea || "",
            NumberOfAccessPoints: payload.NumberOfAccessPoints || "",
            EndUserPolicy: payload.EndUserPolicy || "",
            userName: sessionStorage.getItem('userName'),
            password: sessionStorage.getItem('password')
        }

        const response = await fetch(apiUrl, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(requestBody),
        });

        const data = await response.json();
        return data;
    } catch (err) {
        console.error("Error fetching data:", err);
        return err.message;;
    }
};

// export const getBBDIA_AP_encrypt = async (payload) => {
//     try {
//         const apiUrl = process.env.REACT_APP_API_URL;
//         const encryptionKey = process.env.REACT_APP_ENCRYPTION_KEY || 'dev-key';

//         // Use environment variable to determine if encryption should be used
//         const useEncryption = process.env.REACT_APP_USE_ENCRYPTION === 'true';

//         // Original request body
//         const originalRequestBody = {
//             Action: "getBBDIA_AP",
//             Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
//             empCount: payload.empCount || "",
//             OfficeArea: payload.OfficeArea || ""
//         };

//         let requestBody;

//         // Only encrypt in production or when explicitly enabled
//         if (useEncryption) {
//             requestBody = {
//                 encData: encryptData(originalRequestBody, encryptionKey)
//             };
//         } else {
//             requestBody = originalRequestBody;
//         }

//         const response = await fetch(apiUrl, {
//             method: "POST",
//             headers: {
//                 "Content-Type": "application/json",
//             },
//             body: JSON.stringify(requestBody),
//         });

//         const responseData = await response.json();

//         // Handle decryption if response is encrypted
//         if (useEncryption && responseData && responseData.encData) {
//             return decryptData(responseData.encData, encryptionKey);
//         }

//         // Return direct response in development
//         return responseData;
//     } catch (err) {
//         console.error("Error fetching data:", err);
//         return err.message;
//     }
// };

export const validateImage = async (payload) => {
    try {
        const apiUrl = process.env.REACT_APP_ONEML_API_URL + "/api/validate-Image";

        const requestBody = {
            oppID: payload.oppID || "",
            cafID: payload.cafID || "",
            latitude: payload.latitude || "",
            longitude: payload.longitude || "",
            emp_code: payload.emp_code || "NA",
            image_base64: payload.image_base64 || ""
        }

        const response = await fetch(apiUrl, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(requestBody),
        });

        const data = await response.json();
        return data;
    } catch (err) {
        console.error("Error fetching data:", err);
        return err.message;;
    }
};

export const getLatLong = async (address) => {
    try {
        const apiUrl = process.env.REACT_APP_API_URL;

        const requestBody = {
            Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
            Action: "getLatLong",
            address: address
        };

        const response = await fetch(apiUrl, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(requestBody),
        });

        const data = await response.json();
        return data;
    } catch (err) {
        console.error("Error fetching data:", err);
        return err.message;;
    }
};



export const getAllUsersRoles = async (role) => {
    try {
        const apiUrl = process.env.REACT_APP_ONEML_API_URL + "/ffa/getAllUsersRoles";

        const requestBody = {
            Action: role || ""
        }

        const response = await fetch(apiUrl, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(requestBody),
        });

        const data = await response.json();
        return data;
    } catch (err) {
        console.error("Error fetching data:", err);
        return err.message;;
    }
};


export const getAllUsers = async () => {
    try {
        // console.log(process.env.ONEML_API_URL);
        // console.log(process.env.REACT_APP_API_URL);
        
        const apiUrl = process.env.REACT_APP_ONEML_API_URL + "/ffa/getAllUsers";

        const response = await fetch(apiUrl, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            // body: JSON.stringify(requestBody),
        });

        const data = await response.json();
        return data;
    } catch (err) {
        console.error("Error fetching data:", err);
        return err.message;;
    }
};

export const addUpdateUserRole = async (payload) => {
    try {
        const apiUrl = process.env.REACT_APP_ONEML_API_URL + "/ffa/addUpdateUserRole";
        const requestBody = {
            full_name: payload.full_name || "",
            email: payload.email || "",
            username: payload.username || "",
            emp_id: payload.emp_id || "",
            hotel: payload.hotel || "",
            mra: payload.mra || "",
            pg: payload.pg || "",
            profi: payload.profi || "",
            status: payload.status || ""
        }
        const response = await fetch(apiUrl, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(requestBody),
        });
 
        const data = await response.json();
        return data;
    } catch (err) {
        console.error("Error fetching data:", err);
        return err.message;;
    }
};

export const saveLog = async (payload) => {
    try {
        // const apiUrl = process.env.REACT_APP_ONEML_API_URL + "/getNotificationDetailsForFFAerror";
        const apiUrl = "https://oneml.spectra.co/getNotificationDetailsForFFAerror";
        const requestBody = {
            user_token_error: payload.user_token_error || "",
            user_name: payload.user_name || "",
        }
        const response = await fetch(apiUrl, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(requestBody),
        });
 
        const data = await response.json();
        return data;
    } catch (err) {
        console.error("Error fetching data:", err);
        return err.message;;
    }
};

